import React from "react";
import { Text, Tooltip, useColorMode } from "@chakra-ui/react";
import { FaMoon, MdWbSunny } from "react-icons/all";

import { useConfigurationThemeConsumer, ColorMode } from "ChakraTheme";

import { Icon } from "components/Icon";
import { IconButton } from "components/IconButton";

const DarkModeButton = () => {
  const { dispatch, theme } = useConfigurationThemeConsumer();
  const { toggleColorMode } = useColorMode();
  const darkModeMessage = "Przełącz na tryb nocny";
  const standardModeMessage = "Przełącz na tryb standardowy";

  const message =
    theme.mode === ColorMode.Dark ? standardModeMessage : darkModeMessage;

  return (
    <Tooltip label={message} aria-label={message}>
      <IconButton
        id="dark-mode-btn"
        aria-label={message}
        background="transparent"
        size="lg"
        icon={
          <Text fontSize="lg">
            <Icon
              color="black.900"
              icon={theme.mode === ColorMode.Dark ? MdWbSunny : FaMoon}
            />
          </Text>
        }
        onClick={() => {
          if (theme.mode === ColorMode.Dark) {
            dispatch({ type: "LIGHT_MODE" });
            toggleColorMode();
            return;
          }
          dispatch({ type: "DARK_MODE" });
          toggleColorMode();
        }}
      />
    </Tooltip>
  );
};

export { DarkModeButton };
